import { useContext } from 'react'
import { Intl } from './intl'

import IntlContext from './IntlContext'


const useIntl = () => useContext<Intl>(IntlContext)


export default useIntl
